import * as Models from "../Models";
import * as Common from "../Common/modules";

export interface IWorkIssueApiClient {
    postWorkIssue: (issue: Models.Issues.Issue) => ng.IPromise<Models.Issues.IIssueResponse>;
    getWorkIssue: (workIssueId: number) => ng.IPromise<Models.Issues.IIssueResponse>;
    getWorkIssues: (searchParameters: Models.Issues.SearchWorkIssuesRequest) => ng.IPromise<Array<Models.Issues.IBaseIssue>>;
    getWorkIssuesForCustomerDetail: (searchParameters: Models.Issues.SearchWorkIssuesRequest) => ng.IPromise<Array<Models.Issues.IBaseIssue>>;
    postComment: (commentModel: Models.Issues.Comment) => ng.IPromise<Array<Models.Issues.Comment>>;
    getComments: (workIssueId: number) => ng.IPromise<Array<Models.Issues.Comment>>;
    getIssueStatuses: () => ng.IPromise<Array<Models.Issues.IssueStatus>>;
    getAllIssueStatuses: () => ng.IPromise<Array<Models.Issues.IssueStatus>>;
    getIssueTypes: () => ng.IPromise<Array<Models.Issues.IssueType>>;
    getCustomerIssueTypes: (igsCustomerNumber: string) => ng.IPromise<Array<Models.Issues.IssueType>>;
    getAssignableTeams: (igsCustomerNumber: string) => ng.IPromise<Array<Models.Issues.Team>>;
    getTeams: () => ng.IPromise<Array<Models.Issues.Team>>;
    getPriorities: () => ng.IPromise<Array<Models.Issues.IssuePriority>>;
    getUsersFromTeams: (teamGuid: string) => ng.IPromise<Array<any>>;
    getNotificationBarInfo: (userId: string) => ng.IPromise<any>;
    markIssueAsSeen: (issueId: number, userId: string) => ng.IPromise<any>;
    getCommentsForIssue: (issueId: number) => ng.IPromise<Array<Models.Issues.Comment>>;
    getHistoryForIssue: (issueId: number) => ng.IPromise<Array<Models.Issues.History>>;
    getOpenIssueCount: (igsCustomerNumber: string | null, partnerSystemNumber: string | null) => ng.IPromise<number>;
    constants: any;
}

export class WorkIssueApiClient implements IWorkIssueApiClient {

    public prefix: string;

    public constants = {
        OperationsGroupId: "f4211f72-c2ed-4c58-869d-6754244b0662"
    };

    public static $inject = ['igs.apiClientService'];

    constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
        this.prefix = "WorkIssue";
    }

    public postWorkIssue = (issue: any): ng.IPromise<Models.Issues.IIssueResponse> => {
        var url = `${this.prefix}/PostWorkIssue`;
        return this.igsApiClientService.post(url, issue);
    }

    public getWorkIssue = (workIssueId: number): ng.IPromise<Models.Issues.IIssueResponse> => {
        var url = `${this.prefix}/GetWorkIssue`;
        var postObject = { issueId: workIssueId };
        return this.igsApiClientService.post(url, postObject);
    }

    public getCommentsForIssue = (issueId: number): ng.IPromise<Array<Models.Issues.Comment>> => {
        var url = `${this.prefix}/GetCommentsForIssue/${issueId}`;
        return this.igsApiClientService.get(url);
    }

    public getHistoryForIssue = (issueId: number): ng.IPromise<Array<Models.Issues.History>> => {
        var url = `${this.prefix}/GetHistoryForIssue/${issueId}`;
        return this.igsApiClientService.get(url);
    }

    public getWorkIssues = (searchParameters: Models.Issues.SearchWorkIssuesRequest): ng.IPromise<Array<Models.Issues.IBaseIssue>> => {
        var url = `${this.prefix}/SearchWorkIssues`;
        return this.igsApiClientService.post(url, searchParameters);
    }

    public getWorkIssuesForCustomerDetail = (searchParameters: Models.Issues.SearchWorkIssuesRequest): ng.IPromise<Array<Models.Issues.IBaseIssue>> => {
        var url = `${this.prefix}/SearchWorkIssuesForCustomerDetail`;
        return this.igsApiClientService.post(url, searchParameters);
    }

    public postComment = (commentModel: Models.Issues.Comment): ng.IPromise<Array<Models.Issues.Comment>> => {
        var url = `${this.prefix}/PostComment`;
        var config = { nomask: true };
        return this.igsApiClientService.post(url, commentModel, config);
    }

    public getComments = (issueId: number): ng.IPromise<Array<Models.Issues.Comment>> => {
        var url = `${this.prefix}/GetCommentsForIssue/${issueId}`;
        return this.igsApiClientService.get(url);
    }

    public getIssueStatuses = (): ng.IPromise<Array<Models.Issues.IssueStatus>> => {
        var url = `${this.prefix}/GetIssueStatuses`;
        return this.igsApiClientService.get(url);
    }

    public getAllIssueStatuses = (): ng.IPromise<Array<Models.Issues.IssueStatus>> => {
        var url = `${this.prefix}/GetAllIssueStatuses`;
        return this.igsApiClientService.get(url);
    }

    public getIssueTypes = (): ng.IPromise<Array<Models.Issues.IssueType>> => {
        var url = `${this.prefix}/GetIssueTypes`;
        return this.igsApiClientService.get(url);
    }

    public getCustomerIssueTypes = (igsCustomerNumber: string): ng.IPromise<Array<Models.Issues.IssueType>> => {
        var url = `${this.prefix}/GetCustomerIssueTypes/${igsCustomerNumber}`;
        return this.igsApiClientService.get(url);
    }

    public getAssignableTeams = (igsCustomerNumber: string): ng.IPromise<Array<Models.Issues.Team>> => {
        var url = `${this.prefix}/GetAssignableTeams/${igsCustomerNumber}`;
        return this.igsApiClientService.get(url);
    }

    public getTeams = (): ng.IPromise<Array<Models.Issues.Team>> => {
      var url = `${this.prefix}/GetTeams`;
      return this.igsApiClientService.get(url);
    }

    public getUsersFromTeams = (teamGuid: string): ng.IPromise<Array<any>> => {
        var url = `${this.prefix}/GetUsersFromTeam/${teamGuid}`;
        var config = { nomask: true };
        return this.igsApiClientService.get(url, config);
    }

    public getPriorities = (): ng.IPromise<Array<Models.Issues.IssuePriority>> => {
        var url = `${this.prefix}/GetPriorities`;
        return this.igsApiClientService.get(url);
    }

    public getNotificationBarInfo = (userId: string): ng.IPromise<any> => {
        var url = `${this.prefix}/GetNotificationBarInfo`;
        var config = { nomask: true };
        var postObject = { userId };
        return this.igsApiClientService.post(url, postObject, config);
    }

    public markIssueAsSeen = (issueId: number, userId: string): ng.IPromise<any> => {
        var url = `${this.prefix}/MarkIssueAsSeen`;
        var config = { nomask: true };
        var postObject = { issueId, userId };
        return this.igsApiClientService.post(url, postObject, config);
    }

    public getOpenIssueCount = (igsCustomerNumber: string | null, partnerSystemNumber: string | null): ng.IPromise<number> => {
        const baseUrl = "WorkIssues/OpenIssueCount"
        
        var url = baseUrl;
        if (igsCustomerNumber) {
            url += `?igsCustomerNumber=${igsCustomerNumber}`;
        }
        else if (partnerSystemNumber) {
            url += `?partnerSystemNumber=${partnerSystemNumber}`;
        }
        
        return this.igsApiClientService.get(url);
    }
}
